module.exports = __webpack_public_path__ + "media/small/real_estate_land_sale-small-d475ae62.jpeg";